<template>
  <div>
    <div class="menuFrame">
      <div class="container py-3">
        <div
          class="row flex-nowrap mx-2 pt-3 justify-content-between align-items-center"
        >
          <a href="https://www.chanchao.com.tw/en/">
            <div class="d-flex align-items-center">
              <img
                src="../../assets/images/ChanChaoLogo.png"
                class="navLogo mt-2"
              />
              <div class="mx-2 logoText text-dark font-weight-nomal">
                <div>চ্যান চাও মেম্বার</div>
              </div>
            </div>
          </a>

          <div>
            <select
              class="form-control language-select"
              v-model="selectedLang"
              @change="switchLanguage"
            >
              <option
                v-for="lang in languages"
                :key="lang.value"
                :value="lang.value"
              >
                {{ lang.label }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row formFrame m-1 py-2">
          <div class="rightline col-md-7 my-4 px-4">
            <div class="d-flex align-items-center mb-4">
              <img
                src="../../assets/images/signupIcon.png"
                class="mr-2 mb-2"
                style="width: 40px; height: 40px"
                alt=""
              />
              <h4>সাইন আপ করুন</h4>
            </div>
            <form>
              <div class="form-group h6">
                <label for="signupEmail"
                  >ইমেইল অ্যাড্রেস
                  <span class="input-note">
                    *এটি আপনার অ্যাকাউন্ট, রেজিস্ট্রেশন সম্পন্ন হলে এটি পরিবর্তন
                    করা যাবে না।</span
                  >
                </label>
                <input
                  type="email"
                  name="email"
                  class="form-control form-group"
                  placeholder="যাচাইকরণ কোড পেতে একটি বৈধ ইমেল ঠিকানা লিখুন।"
                  id="signupEmail"
                  maxlength="50"
                  aria-describedby="emailHelp"
                  v-model="email"
                  :class="{ 'is-invalid': errors.first('email') }"
                  v-validate="'required|email'"
                  ref="signupEmail"
                />

                <span
                  class="text-danger"
                  style="font-size: 10px"
                  v-if="errors.first('email')"
                  >{{ errors.first("email") }}
                </span>
              </div>
              <div class="form-group h6">
                <label for="signupPassword"
                  >যাচাইকরণ কোড লিখুন <span class="input-note"> *</span></label
                >

                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="6 digit code"
                    id="signupPassword"
                    maxlength="6"
                    v-model="verificationcode"
                    name="text"
                    :class="{ 'is-invalid': errors.first('text') }"
                    v-validate="'required'"
                    ref="signupPassword"
                  />

                  <div class="input-group-prepend">
                    <button
                      class="btn btn-secondary ml-3 py-0 px-3 rounded"
                      style="font-size: 16px"
                      @click.prevent="getverification"
                      type="button"
                    >
                      কোড পান
                    </button>
                  </div>
                </div>

                <div>
                  <em style="font-size: 13px; color: grey"
                    >এই বোতামে ক্লিক করুন, উপরে দেওয়া ইমেল ঠিকানায় একটি
                    যাচাইকরণ কোড পাঠানো হবে।</em
                  >
                </div>

                <span
                  class="text-danger"
                  style="font-size: 10px"
                  v-if="errors.first('text')"
                  >ভেরিফিকেশন ফিল্ডটি পূরণ করা আবশ্যক।
                </span>
              </div>
              <div class="form-group h6">
                <label for="signupName"
                  >নাম<span class="input-note"> *</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  placeholder="ইভেন্ট সনাক্তকরণের জন্য আপনার প্রকৃত নাম লিখুন।"
                  id="signupName"
                  maxlength="30"
                  v-model="name"
                  name="name"
                  :class="{ 'is-invalid': errors.first('name') }"
                  v-validate="'required'"
                  ref="signupName"
                />
                <span
                  class="text-danger"
                  style="font-size: 10px"
                  v-if="errors.first('name')"
                  >নাম ঘরটি পূরণ করা আবশ্যক।
                </span>
              </div>
              <div class="form-group h6">
                <label for="exampleInputPassword1"
                  >মোবাইল<span class="input-note"> *</span></label
                >
                <vue-tel-input
                  class="form-control"
                  type="tel"
                  maxLen="20"
                  v-bind="bindProps"
                  v-model="allPhone"
                  name="interphone"
                  :class="{ 'is-invalid': errors.first('interphone') }"
                  v-validate="'required'"
                ></vue-tel-input>
                <span
                  class="text-danger"
                  style="font-size: 10px"
                  v-if="errors.first('interphone')"
                  >মোবাইল নম্বর ঘরটি পূরণ করা আবশ্যক।
                </span>
              </div>

              <div class="form-group h6">
                <label for="signupPassword1"
                  >পাসওয়ার্ড<span class="input-note"> *</span></label
                >
                <div class="input-group mb-3">
                  <input
                    type="password"
                    :type="typePwd"
                    name="password"
                    class="form-control"
                    placeholder=" ৮–১৫ অক্ষর"
                    id="signupPassword1"
                    maxlength="20"
                    v-model="password"
                    :class="{ 'is-invalid': errors.first('password') }"
                    v-validate="'required'"
                    ref="password"
                    data-vv-as="Password"
                    autocomplete="off"
                  />
                  <div class="input-group-append">
                    <span
                      class="input-group-text"
                      id="basic-addon2"
                      @click.prevent="showPw"
                    >
                      <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                      <i
                        class="fas fa-eye-slash"
                        v-else-if="typePwd == 'text'"
                      ></i>
                    </span>
                  </div>
                </div>
                <span
                  class="text-danger"
                  style="font-size: 10px"
                  v-if="errors.first('password')"
                  >{{ errors.first("password") }}
                </span>
              </div>

              <div class="form-group h6">
                <label for="signupPassword2"
                  >পাসওয়ার্ড নিশ্চিত করুন<span class="input-note">
                    *</span
                  ></label
                >
                <div class="input-group mb-3">
                  <input
                    type="password"
                    :type="typePwd"
                    class="form-control"
                    placeholder="অনুগ্রহ করে পাসওয়ার্ডটি আবার লিখুন।"
                    id="signupPassword2"
                    maxlength="20"
                    autocomplete="off"
                    v-model="confirmpassword"
                    name="password_confirmation"
                    :class="{
                      'is-invalid': errors.first('password_confirmation'),
                    }"
                    v-validate="'required|confirmed:password'"
                    data-vv-as="Confirm Password"
                    ref="signupPassword2"
                  />
                  <div class="input-group-append">
                    <span
                      class="input-group-text"
                      id="basic-addon2"
                      @click.prevent="showPw"
                    >
                      <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                      <i
                        class="fas fa-eye-slash"
                        v-else-if="typePwd == 'text'"
                      ></i>
                    </span>
                  </div>
                </div>
                <span
                  class="text-danger"
                  style="font-size: 10px"
                  v-if="errors.first('password_confirmation')"
                >
                  {{ errors.first("password_confirmation") }}
                </span>
              </div>
              <div class="form-check ml-1">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="signupCheck"
                  v-model="checkedrule"
                  maxlength="20"
                />
                <label
                  class="form-check-label"
                  for="signupCheck"
                  style="font-size: 15px"
                >
                  <span
                    >আমি … এর বিষয়বস্তু পড়েছি, বুঝেছি এবং গ্রহণ করতে সম্মত
                    হয়েছি।</span
                  >
                  <a
                    href="https://www.chanchao.com.tw/en/otherMember.asp"
                    target="_blank"
                  >
                    সদস্যতার শর্তাবলী</a
                  >
                  <span v-if="checkText" class="text-danger ml-1"
                    >**অনুগ্রহ করে ক্লিক করুন**</span
                  >
                </label>
              </div>

              <button
                type="submit"
                class="btn btn-block btn-primary mt-4"
                @click.prevent="signupBtn"
              >
                অ্যাকাউন্ট তৈরি করুন
              </button>
            </form>

            <hr />
            <div class="linkFrame">
              <span>আগে থেকেই অ্যাকাউন্ট আছে? </span>
              <span>
                <a href="https://www.chanchao.com.tw/accounts/bd/login"
                  >লগইন
                </a>

                <!-- <router-link to="/en/login"> লগইন </router-link>  -->

                /
                <a href="https://www.chanchao.com.tw/accounts/bd/forgetPw"
                  >পাসওয়ার্ড ভুলে গেছেন</a
                >

                <!-- <router-link to="/bd/forgetPw"> পাসওয়ার্ড ভুলে গেছেন</router-link> -->
              </span>
            </div>
          </div>

          <div class="col-md-5 my-4 px-4 lineBottom">
            <div>
              <div class="d-flex align-items-center mb-4">
                <img
                  src="../../assets/images/user.svg"
                  class="mr-3"
                  style="width: 50px; height: 50px"
                  alt=""
                />
                <div>
                  <h4>এখনই আমাদের সঙ্গে যোগ দিন</h4>
                  <h6>বিশেষ সুবিধা উপভোগ করুন!</h6>
                </div>
              </div>
              <p>
                সর্বশেষ প্রদর্শনী আপডেট পান, টিকিট রিডিম ইভেন্টে অংশ নিন, বিশেষ
                সদস্য ছাড় উপভোগ করুন এবং আমাদের নিউজলেটার ও প্রদর্শনী নিউজলেটার
                বিনামূল্যে সাবস্ক্রাইব করুন।
              </p>

              <hr />

              <h4 class="my-4">FAQ</h4>

              <ul class="ml-0 pl-4">
                <li>
                  <a
                    href="https://www.chanchao.com.tw/downloads/%E6%9C%83%E5%93%A1%E8%A8%BB%E5%86%8A%E7%AF%87_En.pdf"
                    target="_blank"
                    >কিভাবে সদস্য হবেন??</a
                  >
                </li>
                <li>
                  <a
                    href="https://www.chanchao.com.tw/downloads/%E9%82%80%E8%AB%8B%E4%BB%A3%E7%A2%BC%E7%B4%A2%E7%A5%A8_En.pdf"
                    target="_blank"
                    >টিকিট কিভাবে রিডিম করবেন?</a
                  >
                </li>
                <li>
                  <a
                    href="https://www.chanchao.com.tw/downloads/%E5%BF%AB%E9%80%9F%E5%85%A5%E5%A0%B4%E7%AF%87(%E6%89%8B%E6%A9%9F%E7%89%88)_En.pdf"
                    target="_blank"
                    >দ্রুত প্রবেশ করবেন কীভাবে?</a
                  >
                </li>
              </ul>

              <div class="d-flex mt-3">
                <a href="//www.chanchao.com.tw/qa.asp" target="_blank"
                  >আরও জানুন<i class="fas fa-external-link-alt ml-2"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from "@/components/footer_en.vue";

export default {
  metaInfo: {
    title: "সাইন আপ করুন - চ্যান চাও প্রদর্শনী হল",
  },
  components: {
    Footer,
  },

  data() {
    return {
      mobile: "",
      mobilecountrycode: "",
      name: "",
      email: "",
      verificationcode: "",
      confirmpassword: "",
      password: "",
      allPhone: "",
      bindProps: {
        mode: "international",
        defaultCountry: "TW",
      },
      checkedrule: false,
      typePwd: "password",
      alertTitle: "",
      alertText: "",
      lastUrl: "",
      checkText: false,

      CSRF_Token: "",
      selectedLang: "bd",
      languages: [
        { label: "中文", value: "tw" },
        { label: "English", value: "en" },
        { label: "Tiếng Việt", value: "vn" },
        { label: "ភាសាខ្មែរ", value: "km" },
        { label: "ภาษาไทย", value: "th" },
        { label: "বাংলা ভাষা", value: "bd" },
      ],
    };
  },

  watch: {
    email: function () {
      const vm = this;
      vm.$refs.signupEmail.style.borderColor = "#ced4da";
    },

    verificationcode: function () {
      const vm = this;
      vm.$refs.signupPassword.style.borderColor = "#ced4da";
    },

    name: function () {
      const vm = this;
      vm.$refs.signupName.style.borderColor = "#ced4da";
    },

    password: function () {
      const vm = this;
      vm.$refs.password.style.borderColor = "#ced4da";
    },

    confirmpassword: function () {
      const vm = this;
      vm.$refs.signupPassword2.style.borderColor = "#ced4da";
    },
  },

  methods: {
    switchLanguage() {
      const langCode = this.selectedLang;

      if (langCode === "tw") {
        window.location.href = `https://www.chanchao.com.tw/accounts/signup`;
      } else {
        window.location.href = `https://www.chanchao.com.tw/accounts/${langCode}/signup`;
      }
    },
    signupBtn() {
      const vm = this;

      // Divide Phone Number

      let countryCode = vm.allPhone
        .substr(1)
        .substring(0, vm.allPhone.indexOf(" ") - 1);
      let phoneNum = vm.allPhone
        .substring(vm.allPhone.indexOf(" "), vm.allPhone.length)
        .replace(/\s*/g, "");

      const signupinfo = {
        Email: vm.email,
        VerificationCode: vm.verificationcode,
        MemberName: vm.name,
        Mobile: phoneNum,
        MobileCountryCode: countryCode,
        spass: vm.password,
        CSRF: vm.CSRF_Token,
      };

      const url = "https://www.chanchao.com.tw/apiLogin2/signup";

      vm.$validator.validate().then((valid) => {
        if (valid) {
          if (vm.password.length > 7) {
            if (vm.checkedrule) {
              vm.$http.post(url, signupinfo).then(function (response) {
                // // console.log(response)
                if (response.data == "200") {
                  vm.alertTitle = "Success";
                  vm.alertText =
                    "অভিনন্দন, আপনার অ্যাকাউন্ট সফলভাবে তৈরি হয়েছে।";
                  vm.alertSuccessSignup();
                } else if (response.data == "252") {
                  vm.alertText =
                    "আপনার ইমেল ইতিমধ্যে নিবন্ধিত। অনুগ্রহ করে লগইন পৃষ্ঠায় যান।";
                  vm.alertError();
                  vm.$refs.signupEmail.style.borderColor = "red";
                } else if (response.data == "253") {
                  vm.alertText =
                    "যাচাইকরণ কোড ভুল হয়েছে, অনুগ্রহ করে নতুন একটি যাচাইকরণ কোড নিন।";

                  vm.alertError();
                  vm.$refs.signupPassword.style.borderColor = "red";
                } else {
                  vm.alertText =
                    "ত্রুটি ঘটেছে, অনুগ্রহ করে আপনার তথ্য যাচাই করে আবার লগইন করুন।";
                  vm.alertError();
                }
              });
            } else {
              vm.alertText =
                "অনুগ্রহ করে সদস্যতার শর্তাবলী গ্রহণ করুন এবং চেকবক্সে ক্লিক করুন।";
              vm.alertError();
              vm.checkText = true;
            }
          } else {
            vm.alertText =
              "অনুগ্রহ করে ৮ থেকে ২০ অক্ষরের মধ্যে একটি মান লিখুন।";
            vm.alertError();
            vm.$refs.password.style.borderColor = "red";
            vm.$refs.signupPassword2.style.borderColor = "red";
          }
        } else {
          vm.alertText = "অনুগ্রহ করে আবশ্যক ঘরগুলি পূরণ করুন।";
          vm.alertError();
        }
      });
    },

    getverification() {
      const vm = this;

      vm.$validator.validate("email").then((valid) => {
        if (valid) {
          if (vm.lastUrl.length === 0) {
            vm.lastUrl = "https://www.chanchao.com.tw/en/member";
          }

          const url = "https://www.chanchao.com.tw/apiLogin2/verification/bd";

          const verificationemail = {
            Email: vm.email,
            CSRF: vm.CSRF_Token,
          };

          vm.$http.post(url, verificationemail).then(function (response) {
            // console.log(response)
            if (response.data == "200") {
              vm.alertText = vm.email;
              vm.alertTitle = "যাচাইকরণ কোড আপনার ইমেলে পাঠানো হয়েছে।";

              vm.alertSuccess();
            } else if (response.data == "252") {
              vm.alertText =
                "আপনার ইমেল ইতিমধ্যে নিবন্ধিত। অনুগ্রহ করে লগইন পৃষ্ঠায় যান।";
              vm.alertError();
              vm.$refs.signupEmail.style.borderColor = "red";
            } else if (response.data == "253") {
              vm.alertText = "অনুগ্রহ করে ইমেল লিখুন।";
              vm.alertError();
              vm.$refs.signupEmail.style.borderColor = "red";
            } else if (response.data == "254") {
              window.location.replace("https://www.chanchao.com.tw/en/");
            } else if (response.data == "255") {
              vm.alertText =
                "দুঃখিত, আপনি একটি অবৈধ ইমেল ডোমেইন লিখেছেন। অনুগ্রহ করে আপনার ইমেল ঠিকানা যাচাই করুন এবং পুনরায় কোড সংগ্রহ করুন।";
              vm.alertError();
              vm.$refs.signupEmail.style.borderColor = "red";
            } else if (response.data == "256") {
              vm.alertText =
                "দুঃখিত, আমরা অস্থায়ী (ডিসপোজেবল) ইমেল ঠিকানা গ্রহণ করি না। অনুগ্রহ করে অন্য একটি ইমেল ঠিকানা ব্যবহার করুন।";
              vm.alertError();
              vm.$refs.signupEmail.style.borderColor = "red";
            } else {
              vm.alertText = "অনুগ্রহ করে আবশ্যক ঘরগুলি পূরণ করুন।";
              vm.alertError();
            }
          });
        } else {
          // 如果 email 驗證失敗，顯示錯誤訊息
          vm.alertText = "অনুগ্রহ করে একটি বৈধ ইমেল ঠিকানা লিখুন।";
          vm.alertError();
          vm.$refs.signupEmail.style.borderColor = "red";
        }
      });
    },

    showPw() {
      const vm = this;
      vm.typePwd = vm.typePwd === "password" ? "text" : "password";
    },
    alertError() {
      const vm = this;
      vm.$swal({
        text: vm.alertText,
        icon: "info",
        confirmButtonText: "OK",
        // animation: false,
        allowOutsideClick: true,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      });
    },

    alertSuccess() {
      const vm = this;

      vm.$swal({
        title: vm.alertTitle,
        text: vm.alertText,
        icon: "success",
        confirmButtonText: "OK",
        // animation: false,
        allowOutsideClick: true,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      });
    },

    alertSuccessSignup() {
      const vm = this;

      vm.$swal({
        title: vm.alertTitle,
        text: vm.alertText,
        icon: "success",
        confirmButtonText: "OK",
        // animation: false,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      }).then(function () {
        if (vm.lastUrl.length > 0) {
          window.location.replace(vm.lastUrl);
        } else {
          window.location.replace("https://www.chanchao.com.tw/en/member"); //注意能否直接到會員中心頁
        }
      });
    },
  },

  created() {
    const vm = this;
    //GET LANDING PAGE

    vm.$http
      .get("https://www.chanchao.com.tw/apiLogin2/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    if (vm.$cookies.get("url")) {
      vm.lastUrl = vm.$cookies.get("url");

      // console.log(vm.lastUrl)
    } else {
      vm.lastUrl = "https://www.chanchao.com.tw/en/member/";
    }

    // // console.log(vm.lastUrl)

    //取得網址內信箱及認證碼

    let getUrlString = location.href;
    let getParams = new URL(getUrlString);

    let memberid = getParams.searchParams.get("e");
    let vCode = getParams.searchParams.get("v");

    vm.email = memberid;
    vm.verificationcode = vCode;

    //更換英文語系
    vm.$i18n.locale = "en";
  },
};
</script>

<style lang="scss">
//Swal setting
.swal2-popup {
  font-size: 13px !important;
}

.swal2-styled.swal2-confirm {
  font-size: 12px;
}

.menuFrame {
  background-color: #f2f2f2;
  min-height: 100%;
}

.navLogo {
  height: 55px;
}

.formFrame {
  background-color: #ffffff;
  margin-top: 40px;
  border-radius: 10px;
  box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
}

.rightline {
  border-right: 1px solid #ccc;
}

.navEnText:hover {
  color: rgb(34, 34, 34) !important;
}

.input-note {
  font-size: 14px;
  color: rgb(190, 67, 67);
}

input::-webkit-input-placeholder {
  /* placeholder*/
  color: #aab2bd;
  font-size: 14px;
}

.linkFrame {
  font-size: 15px;
}

.logoText {
  font-size: 20px;
}

@media (max-width: 768px) {
  .navLogo {
    height: 50px;
  }
  .rightline {
    border-right: 0px;
  }

  .lineBottom {
    border-top: 0.5px solid rgb(230, 227, 227);
    padding-top: 30px;
  }

  .navEnText {
    display: none;
  }
  .logoText {
    font-size: 16px;
  }
}

@media (max-width: 992px) {
  .auth-code {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>
